//// Application Packages
import React from 'react'
import { useSelector } from 'react-redux'

//// Application Slices
import { selectSettings } from '../../reducers/settingSlice'
import { selectForms } from '../../reducers/formSlice'

//// Application Components
import StateSelectorComponent from '../conditional-components/state-selector-component'

//// Carbon Components
import {
    TextInput,
    TextArea,
    Select,
    SelectItem,
    DatePicker,
    DatePickerInput,
    Button,
} from '@carbon/react'

//// Carbon Icons
import { Subtract } from '@carbon/icons-react'

//// Static Constants

//////// Component
const AdditionalDisciplineHistoryDisciplinaryActionComponent = ({
    number,
    handleData,
    handleSubtractAdditionalDisciplineHistoryForm,
}) => {
    //////// Hooks

    //////// State

    //////// Slices
    const settingsData = useSelector(selectSettings)
    const formsData = useSelector(selectForms)

    //// Slice Data
    const digital_name = settingsData?.['form']?.['digital_name']
    const digital_sub_name = 'action'

    //////// Search Params

    //////// Methods

    //////// Functional Methods

    //////// Memoization

    //////// Effects/Side Effects

    //////////////// Render & Return
    return (
        <>
            <div>
                <h4>Additional Discipline (Disciplinary Action):</h4>

                <TextInput
                    className="required"
                    labelText="Name of Agency:"
                    id={`RSD34B` + number}
                    name={`RSD34B` + number}
                    placeholder=""
                    value={
                        formsData[digital_name]?.[digital_sub_name]?.values?.[
                            `RSD34B` + number
                        ]
                    }
                    maxLength="60"
                    type="text"
                    onChange={handleData}
                    invalid={
                        formsData[digital_name]?.[digital_sub_name]?.errors?.[
                            `RSD34B` + number
                        ]
                    }
                    invalidText={
                        formsData[digital_name]?.[digital_sub_name]?.errors?.[
                            `RSD34B` + number + 'ErrMsg'
                        ]
                    }
                />

                <StateSelectorComponent
                    digital_name={digital_name}
                    digital_sub_name={digital_sub_name}
                    value_key={['STATEB' + number]}
                    country=""
                />

                <DatePicker
                    className="required"
                    dateFormat="m/d/Y"
                    datePickerType="single"
                    onChange={(e) => handleData(e, ['RSD36B' + number])}
                    onClose={(e) => handleData(e, ['RSD36B' + number])}
                    value={
                        formsData[digital_name]?.[digital_sub_name]?.values?.[
                            `RSD36B` + number
                        ]
                    }
                >
                    <DatePickerInput
                        className="required"
                        labelText="Action Date:"
                        id={`RSD36B` + number}
                        name={`RSD36B` + number}
                        placeholder="MM/DD/YYYY"
                        type="text"
                        invalid={
                            formsData[digital_name]?.[digital_sub_name]
                                ?.errors?.[`RSD36B` + number]
                        }
                        invalidText={
                            formsData[digital_name]?.[digital_sub_name]
                                ?.errors?.[`RSD36B` + number + 'ErrMsg']
                        }
                    />
                </DatePicker>

                <TextInput
                    className="required"
                    labelText="Final Action:"
                    id={`FIN_ACTB` + number}
                    name={`FIN_ACTB` + number}
                    placeholder=""
                    value={
                        formsData[digital_name]?.[digital_sub_name]?.values?.[
                            `FIN_ACTB` + number
                        ]
                    }
                    maxLength="60"
                    type="text"
                    onChange={handleData}
                    invalid={
                        formsData[digital_name]?.[digital_sub_name]?.errors?.[
                            `FIN_ACTB` + number
                        ]
                    }
                    invalidText={
                        formsData[digital_name]?.[digital_sub_name]?.errors?.[
                            `FIN_ACTB` + number + 'ErrMsg'
                        ]
                    }
                />

                <Select
                    className="required"
                    defaultValue={
                        formsData[digital_name]?.[digital_sub_name]?.values?.[
                            `RSD39B` + number
                        ]
                    }
                    value={
                        formsData[digital_name]?.[digital_sub_name]?.values?.[
                            `RSD39B` + number
                        ]
                    }
                    helper=""
                    labelText="Under Appeal:"
                    id={`RSD39B` + number}
                    name={`RSD39B` + number}
                    onChange={handleData}
                    invalid={
                        formsData[digital_name]?.[digital_sub_name]?.errors?.[
                            `RSD39B` + number
                        ]
                    }
                    invalidText={
                        formsData[digital_name]?.[digital_sub_name]?.errors?.[
                            `RSD39B` + number + 'ErrMsg'
                        ]
                    }
                >
                    <SelectItem text="Choose an option" value="" />
                    <SelectItem text="Yes" value="Y" />
                    <SelectItem text="No" value="N" />
                    <SelectItem text="No Answer" value="NO" />
                </Select>

                <TextArea
                    className="required"
                    labelText="Applicant Statement:"
                    id={`LIC_NTSB` + number}
                    name={`LIC_NTSB` + number}
                    placeholder=""
                    value={
                        formsData[digital_name]?.[digital_sub_name]?.values?.[
                            `LIC_NTSB` + number
                        ]
                    }
                    maxLength="4000"
                    type="textarea"
                    onChange={handleData}
                    invalid={
                        formsData[digital_name]?.[digital_sub_name]?.errors?.[
                            `LIC_NTSB` + number
                        ]
                    }
                    invalidText={
                        formsData[digital_name]?.[digital_sub_name]?.errors?.[
                            `LIC_NTSB` + number + 'ErrMsg'
                        ]
                    }
                />

                <div className="half-width-button-with-icon-group">
                    <div className="half-width-button-with-icon-group-item">
                        <Button
                            className="fldoh-btn"
                            name={number}
                            type="button"
                            kind="danger"
                            size="md"
                            onClick={
                                handleSubtractAdditionalDisciplineHistoryForm
                            }
                        >
                            Remove
                            <Subtract />
                        </Button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AdditionalDisciplineHistoryDisciplinaryActionComponent
